import { MatchSearchCriteria } from "@app/core/match/domain/match-search-criteria";
import { dateToString } from "@app/presentation/utils/text.utils";

export class MatchSearchCriteriaMapper {
  static serialize(criteria: MatchSearchCriteria) {
    const result: Record<string, any> = {
      //If the value is null, the property is not added to the object
      ...(criteria.search ? { search: criteria.search } : {}),
      limit: criteria.limit,
      offset: criteria.offset,
      //If the value is null, the property is not added to the object
      ...(criteria.startDate
        ? { start_date: dateToString(criteria.startDate) }
        : {}),
      //If the value is null, the property is not added to the object
      ...(criteria.endDate ? { end_date: dateToString(criteria.endDate) } : {}),
      //If the value is null, the property is not added to the object
      ...(criteria.club ? { club: criteria.club } : {}),
      //If the value is null, the property is not added to the object
      ...(criteria.order ? { order: criteria.order } : {}),
    };

    // Handle multiple result values to generate &result=victory&result=defeat format
    if (criteria.result && criteria.result.length > 0) {
      result['result'] = criteria.result;
    }

    return result;
  }
}
